// extracted by mini-css-extract-plugin
export default {"toasts":"_2kUCVS5tak9PztZm8gzlG9"};